module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m-b-20"
  }, [_c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addShow),
      expression: "addShow"
    }],
    staticClass: "btn-link-large add-btn",
    attrs: {
      "to": "add"
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("  添加岗位\n\t\t\t")])]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData
    },
    on: {
      "selection-change": _vm.selectItem
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "岗位名称",
      "prop": "name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "备注",
      "prop": "remark"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "prop": "status",
      "width": "100"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('div', [_vm._v("\n            " + _vm._s(_vm._f("status")(scope.row.status)) + "\n          ")])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "200"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('div', [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.editShow),
            expression: "editShow"
          }]
        }, [_c('router-link', {
          staticClass: "btn-link edit-btn",
          attrs: {
            "to": {
              name: 'positionEdit',
              params: {
                id: scope.row.id
              }
            }
          }
        }, [_vm._v("\n  \t\t\t\t\t\t编辑\n  \t\t\t\t\t\t")])]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.deleteShow),
            expression: "deleteShow"
          }]
        }, [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.confirmDelete(scope.row)
            }
          }
        }, [_vm._v("\n  \t\t\t\t\t\t删除\n  \t\t\t\t\t\t")])])])]
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pos-rel p-t-20"
  }, [_c('btnGroup', {
    attrs: {
      "selectedData": _vm.multipleSelection,
      "type": 'admin/posts'
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5193b263!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Administrative/structures/position/list.vue
// module id = 1864
// module chunks = 2